import { forwardRef, Ref } from "react";
import { getHAFlag } from "components/common/HealthAuthority/HealthAuthority.utils";
import Avatar, { TAvatarProps } from "components/shared/Avatar";
import { TCountry } from "utils/constants/countries.constants";

type TFlagProps = Omit<TAvatarProps, "src"> & {
  country: keyof TCountry;
  tenantId?: string;
};

const Flag = forwardRef((props: TFlagProps, ref: Ref<HTMLDivElement>) => {
  const { country, tenantId, ...restProps } = props;

  const flag = getHAFlag({ tenantId, country });

  return country ? (
    <Avatar ref={ref} src={flag} size={18} {...restProps} />
  ) : null;
});

export default Flag;
